import React from 'react';

const ObservationCategoryPicker = ({
  categories = [],
  selectedCategories = [],
  disabled = false,
  compact = false,
  onToggle
}) => {
  if (!categories.length) {
    return (
      <div className="approved-requests-page__file-empty">
        No hay categorías disponibles para adjuntar archivos.
      </div>
    );
  }

  return (
    <div
      className={`approved-requests-page__file-category-picker${compact ? ' approved-requests-page__file-category-picker--compact' : ''}`}
      aria-label="Categorías del archivo"
    >
      {!compact && (
        <div className="approved-requests-page__file-category-picker-label">
          Categoría del archivo <span aria-hidden>*</span>
        </div>
      )}
      <div className="approved-requests-page__file-category-options">
        {categories.map((category) => {
          const checked = selectedCategories.includes(category.alias);
          return (
            <label
              key={category.alias || category.id}
              className={`approved-requests-page__file-category-option${checked ? ' is-selected' : ''}${disabled ? ' is-disabled' : ''}`}
            >
              <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                onChange={() => onToggle?.(category.alias)}
              />
              <span>{category.name || category.alias}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default ObservationCategoryPicker;
